import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { getNotic } from '../Store/ActionCreators/NotifactionActionCreator';
import Navbar from '../User/Navbar';
import Footer from '../User/Footer';

export default function Result() {
  const Notifactionlist = useSelector((state)=>state.NoticStateData)
  const result = Notifactionlist.filter(item => item.category === "Result");
  const dispatch = useDispatch()
  useEffect(()=>{
    dispatch(getNotic())
  })
  return (
    <>
    <Navbar/>
      <div className="container">
        <div className="card cardItem mt-5">
        <h6 className="title bg-danger text-white p-2 text-center">Result</h6>
        {result.length > 0 ? result.map((n, i) => (
        <p key={i} style={{fontWeight:"bold"}}>
        <Link to={`/notifactionview/${n._id}`} target="_blank">{n.titlename}</Link>
        </p>
        )) : <p>No Answer Key Available</p>}
      </div>
      </div>
      <Footer/>
    </>
  )
}

